"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const bp = {
  small: '576px',
  medium: '768px',
  large: '992px',
  xlarge: '1200px',
  heightMedium: '800px',
  heightSmall: '650px'
};
var _default = exports.default = bp;